import { PromoStore } from "@infrastructure/stores/promo.store";
import { PromoClient, PromoCode } from "@infrastructure/clients/http/clients/promo.client";
import { catchError } from "@shared/utils/errors/catchError";
import { HandleableError } from "@shared/utils/errors/handleableError";

class PromoServiceClass {
  getStore() {
    return PromoStore;
  }

  /**
   * Загрузить список доступных промокодов с бэка
   */
  async loadPromoList(): Promise<void> {
    const promoClient = new PromoClient();
    const [error, result] = await catchError(promoClient.getPromoList());

    if (error) {
      console.error("[PromoService] Failed to load promo list:", error);
      if (error instanceof HandleableError) {
        error.handle();
        error.showError();
      }
      return;
    }

    PromoStore.setPromoList(result);
  }

  /**
   * Загрузить активный промокод пользователя с бэка
   */
  async loadActivePromo(): Promise<void> {
    const promoClient = new PromoClient();
    const [error, result] = await catchError(promoClient.getActivePromo());

    if (error) {
      console.error("[PromoService] Failed to load active promo:", error);
      // Не показываем ошибку, если просто нет активного промокода
      PromoStore.setActivePromo(null);
      return;
    }

    PromoStore.setActivePromo(result);
  }

  /**
   * Активировать промокод
   */
  async activatePromo(code: string): Promise<PromoCode | null> {
    const promoClient = new PromoClient();
    const [error, result] = await catchError(promoClient.activatePromo(code));

    if (error) {
      console.error("[PromoService] Failed to activate promo:", error);
      if (error instanceof HandleableError) {
        error.handle();
        error.showError();
      }
      throw error;
    }

    // Обновляем активный промокод в store
    PromoStore.setActivePromo(result);
    return result;
  }

  /**
   * Деактивировать активный промокод
   */
  async deactivatePromo(): Promise<void> {
    const promoClient = new PromoClient();
    const [error] = await catchError(promoClient.deactivatePromo());

    if (error) {
      console.error("[PromoService] Failed to deactivate promo:", error);
      if (error instanceof HandleableError) {
        error.handle();
        error.showError();
      }
      throw error;
    }

    // Обновляем store
    PromoStore.setActivePromo(null);
  }
}

export const PromoService = new PromoServiceClass();

